export default __webpack_public_path__ + "static/media/russian poker-09.6f91bd6b.png";